import DefinitionTypes from "../definition-types";
import {
  sortDiscoveryKPIsByImportance,
  sortDiscoveryKPIsByValue
} from "../sorting";
import ViewValueHypothesisKPIsBy from "../view-value-hypothesis-kpis-by";

interface DiscoveryKPI {
  kpiCode?: string;
  selected: boolean;
  relevant: boolean;
  inScope: boolean;
  hasImpactValue: boolean;
  hasImpactPercentage: boolean;
  hasFormula: boolean;
  order: number;
  importance: number;
  definition: {
    name: string;
    metricMappings?: string[];
    oneTimeBenefit?: boolean;
    status?: string;
    type?: string;
    noFormulaReason?: string;
    formula?: string;
  };
  lowImpactValue?: number | null;
  expectedImpactValue?: number | null;
  potentialImpactValue?: number | null;
}

export const impactValueKPIsFilter = (
  kpis: DiscoveryKPI[] = []
): DiscoveryKPI[] =>
  kpis.filter(
    (kpi) =>
      kpi.selected &&
      kpi.relevant &&
      kpi.hasImpactValue &&
      !kpi.definition.oneTimeBenefit
  );

export const impactPercentageKPIsFilter = (
  kpis: DiscoveryKPI[] = []
): DiscoveryKPI[] =>
  kpis.filter(
    (kpi) =>
      kpi.selected &&
      kpi.relevant &&
      !kpi.hasImpactValue &&
      kpi.hasImpactPercentage
  );

export const additionalBenefitsKPIFilter = (
  kpis: DiscoveryKPI[]
): DiscoveryKPI[] =>
  kpis.filter((kpi) => kpi.selected && kpi.relevant && !kpi.hasImpactValue);

export const strategicKPIsFilter = (
  kpis: DiscoveryKPI[] = []
): DiscoveryKPI[] =>
  kpis.filter(
    (kpi) => kpi.selected && !kpi.hasImpactValue && !kpi.hasImpactPercentage
  );

export const selectedKPIsFilter = (kpis: DiscoveryKPI[] = []): DiscoveryKPI[] =>
  kpis.filter((kpi) => isSelectedDiscoveryKPI(kpi));

export const isSelectedDiscoveryKPI = (kpi: DiscoveryKPI): boolean =>
  kpi.selected && kpi.relevant && kpi.inScope;

interface SortKPIsByImportanceParams {
  kpis: DiscoveryKPI[];
}

export const sortKPIsByImportance = ({
  kpis
}: SortKPIsByImportanceParams): void => {
  kpis.sort(sortDiscoveryKPIsByImportance);
};

interface SortKPIsForValueHypothesisParams {
  kpis: DiscoveryKPI[];
  viewValueHypothesisKPIsBy: string;
  scenario: number;
}

export const sortKPIsForValueHypothesis = ({
  kpis,
  viewValueHypothesisKPIsBy,
  scenario
}: SortKPIsForValueHypothesisParams): void => {
  if (viewValueHypothesisKPIsBy === ViewValueHypothesisKPIsBy.VALUE) {
    kpis.sort(sortDiscoveryKPIsByValue(scenario));
  } else {
    kpis.sort(sortDiscoveryKPIsByImportance);
  }
};

interface IsCustomKPIParams {
  discoveryKPI: DiscoveryKPI;
}

export const isCustomKPI = ({ discoveryKPI }: IsCustomKPIParams): boolean => {
  return discoveryKPI?.definition?.status === DefinitionTypes.NEW;
};

interface GetValueMapKPIsParams {
  discoveryKPIs: DiscoveryKPI[];
}

export const getValueMapKPIs = ({
  discoveryKPIs
}: GetValueMapKPIsParams): DiscoveryKPI[] => {
  return discoveryKPIs.filter((kpi) => kpi.relevant && kpi.inScope);
};

interface IsQuantifiedKPIParams {
  discoveryKPI: DiscoveryKPI;
}

export const isQuantifiedKPI = ({
  discoveryKPI
}: IsQuantifiedKPIParams): boolean => {
  console.log(
    "discoveryKPI",
    discoveryKPI?.definition?.type,
    !discoveryKPI?.hasImpactValue,
    discoveryKPI?.definition?.noFormulaReason,
    discoveryKPI?.definition?.formula
  );

  return discoveryKPI.hasFormula;
};
